<template>
  <div v-if="!medium" class="chevron" :class="{ invert }">
    <IconChevronDownSmall v-if="state === 'down'" />
    <IconChevronUpSmall v-else-if="state === 'up'" />
    <IconChevronUpDownSmall v-else />
  </div>
  <div v-else class="chevron-medium" :class="{ invert }">
    <IconChevronUp v-if="state === 'up'" />
    <IconChevronUp v-if="state === 'down'" class="rotated" />
  </div>
</template>

<script setup lang="ts">
import IconChevronDownSmall from '../assets/icons/IconChevronDownSmall.vue'
import IconChevronUpSmall from '../assets/icons/IconChevronUpSmall.vue'
import IconChevronUpDownSmall from '../assets/icons/IconChevronUpDownSmall.vue'
import IconChevronUp from '../assets/icons/IconChevronUp.vue'

defineProps<{
  state?: 'up' | 'down' | 'none' | undefined
  invert?: boolean
  medium?: boolean
}>()
</script>

<style lang="scss" scoped>
.chevron {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  &.invert {
    color: #fff;
  }
}

.chevron-medium {
  display: flex;
  align-items: center;
  justify-content: center;
  &.invert {
    color: #fff;
  }
  .rotated {
    transform-origin: center;
    transform: rotate(180deg);
  }
}
</style>
